import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import print from 'print-js';
import axios from 'axios';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import FPPricingSlider from '../../components/Sliders/FPPricingSlider';
import { API_HOST, STATIC_HOST, HTTP_PROTOCOL } from '../../config';
import { getLabels4Booking, getPricingInfos, fpLabel, fpBook, updateBooking, getBooking } from '../../state/services/bookingService';
import { timeDiff } from '../../commons/constants';

class LabelPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            identifier: null,
            errorMessage: null,
            isShowFPPricingSlider: false,
            loadingPricingInfos: false,
            isBooking:false,
            pricingInfos: [],
            selectedLabelType: 'label',
            puTzEditMode: false,
            puDateTime: null,
        };

        this.toggleFPPricingSlider = this.toggleFPPricingSlider.bind(this);
    }

    static propTypes = {
        match: PropTypes.object,
        getLabels4Booking: PropTypes.func.required,
        bookingLabels: PropTypes.object,
        booking: PropTypes.array,
        errorMessage: PropTypes.string,
        clientname: PropTypes.string,
        getPricingInfos: PropTypes.func.isRequired,
        pricingInfos: PropTypes.array,
        loadingBookingLabel: PropTypes.bool,
        fpLabel: PropTypes.func.isRequired,
        fpBook: PropTypes.func.isRequired,
        updateBooking: PropTypes.func.isRequired,
    };

    componentDidMount() {

        const identifier = this.props.match.params.id;
        if (identifier && identifier === 'scan-failed') {
            const params = new URLSearchParams(window.location.search);

            if (params.get('reason') === 'address') {
                this.setState({errorMessage: 'There is an issue while scanning data to build label. Reason: address contains non-utf8 character.'});
            } else if (params.get('reason') === 'sscc') {
                this.setState({errorMessage: 'There is an issue while scanning data to build label. Reason: scanned data is not fetchable or parsable.'});
            } else if (params.get('reason') === 'no-fp-selected') {
                this.setState({errorMessage: 'There is an issue while scanning data to build label. Reason: no freight provider is selected. Please check quotes manually.'});
            } else if (params.get('reason') === 'failed-label-build') {
                this.setState({errorMessage: 'There is an issue while scanning data to build label. Reason: failed to build label. Please check address.'});
            } else {
                this.setState({errorMessage: 'There is an issue while scanning data to build label. Reason: unknown. Please contact support center.'});
            }
            this.setState({identifier});
        } else if (identifier && identifier.length > 32) {
            this.props.getLabels4Booking(identifier, this.state.selectedLabelType);
            
            this.setState({identifier});
        } else {
            this.setState({errorMessage: 'A Freight booking does not exist for this Sales Order. Please go to Pronto Sales Orders, \
                click the "Freight Deliver-ME" button, select a valid freight option and when complete click the "Send Booking Now" button at the bottom of the screen. \
                Your booking will then be ready for freight and freight labels can be printed from the Pronto "Enquire by Package" screen.'});
        }


    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedLabelType !== this.state.selectedLabelType) {
            this.props.getLabels4Booking(this.props.match.params.id, this.state.selectedLabelType);
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {errorMessage, pricingInfos, bookingLabels} = newProps;

        if (errorMessage) {
            if (errorMessage === 'Order does not exist!') {
                this.setState({errorMessage: 'A Freight booking does not exist for this Sales Order. Please go to Pronto Sales Orders, \
                click the "Freight Deliver-ME" button, select a valid freight option and when complete click the "Send Booking Now" button at the bottom of the screen. \
                Your booking will then be ready for freight and freight labels can be printed from the Pronto "Enquire by Package" screen.'});
            } else if (errorMessage.indexOf('Successfully created label') !== -1) {
                const labelUrl = errorMessage.substring(27, errorMessage.length - 1);
                const win = window.open(HTTP_PROTOCOL + '://' + STATIC_HOST + '/pdfs/' + labelUrl, '_blank');
                win.focus();
            } else {
                this.setState({errorMessage});
            }
        }

        if (pricingInfos) {
            this.setState({loadingPricingInfos: false});
        }

        if (bookingLabels && bookingLabels.pickup_timestamp) {
            const puDateTime = moment(bookingLabels.pickup_timestamp).add(timeDiff, 'h').toDate();
            this.setState({puDateTime: puDateTime});
        }
    }

    notify = (text) => toast(text);

    toggleFPPricingSlider() {
        this.setState(prevState => ({isShowFPPricingSlider: !prevState.isShowFPPricingSlider}));
    }

    onClickPreview(url) {
        if (url && url.length > 0) {
            const win = window.open(HTTP_PROTOCOL + '://' + STATIC_HOST + '/pdfs/' + url, '_blank');
            win.focus();
        } else {
            this.notify('Has no label');
        }
    }

    onClickPrint(pdf = null) {
        const {bookingLabels} = this.props;

        if (pdf) {
            print({printable: pdf, type: 'pdf', showModal: true, base64: true});
        } else {
            print({printable: bookingLabels['pdf'], type: 'pdf', showModal: true, base64: true});
        }
    }

    onClickDownload(pdfUrl) {
        const {bookingLabels} = this.props;
        const token = localStorage.getItem('token');

        const options = {
            method: 'post',
            url: HTTP_PROTOCOL + '://' + API_HOST + '/download/',
            headers: {'Authorization': 'JWT ' + token},
            data: {url: pdfUrl, downloadOption: 'zpl', id: bookingLabels['id']},
            responseType: 'blob', // important
        };

        axios(options).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'zpl.zip');
            document.body.appendChild(link);
            link.click();
        });
    }

    bulkBookingUpdate(bookingIds, fieldName, fieldContent) {
        const token = localStorage.getItem('token');

        if (!token) {
            this.notify('Login required!');
            return;
        }

        return new Promise((resolve, reject) => {
            const options = {
                method: 'post',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'JWT ' + token },
                url: HTTP_PROTOCOL + '://' + API_HOST + '/bookings/bulk_booking_update/',
                data: {bookingIds, fieldName, fieldContent},
            };

            axios(options)
                .then(() => {
                    resolve();
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    onClickUseCheapest(quote) {
        const {bookingLabels} = this.props;

        this.bulkBookingUpdate([bookingLabels['id']], 'vx_freight_provider', quote.fp)
            .then(() => {
                window.location.reload(false);
            })
            .catch(() => {
                this.notify('Failed, please contact support center.');
            });
    }

    onSelectPricing(pricingInfo, isLocking) {
        this.notify('Locking is not supported on this page.');
        console.log('Locking is not supported on this page.', isLocking);
        const {bookingLabels} = this.props;

        this.bulkBookingUpdate([bookingLabels['id']], 'vx_freight_provider', pricingInfo.freight_provider)
            .then(() => {
                this.toggleFPPricingSlider();
                window.location.reload(false);
            })
            .catch(() => {
                this.notify('Failed, please contact support center.');
            });
    }

    onClickOpenPricingSlider() {
        const {bookingLabels} = this.props;
        const token = localStorage.getItem('token');

        if (!token) {
            this.notify('Login required!');
            return;
        }

        this.setState({loadingPricingInfos: true});
        this.toggleFPPricingSlider();
        this.props.getPricingInfos(bookingLabels.id);
    }

    onBookCreateLabel() {
        this.setState({isBooking:true});

        try {
            this.props.fpBook(this.props.bookingLabels.id, this.props.bookingLabels.vx_freight_provider)
                .then(async (res) => {
                    if (res.type !== 'BOOK_FAILED')
                        await this.props.fpLabel(this.props.bookingLabels.id, this.props.bookingLabels.vx_freight_provider);  
                    this.setState({isBooking:false});
                })
                .catch((error) => {
                    console.error('Error in fpBook:', error);
                    this.setState({isBooking:false});
                });
        } catch (error) {
            console.error('Error in fpBook:', error);
            this.setState({isBooking:false});
        }
    }

    onClickEditPU() {
        this.setState({puTzEditMode: true});
    }

    onClickSavePU(e) {
        e.preventDefault();

        const {bookingLabels} = this.props;
        const booking = {};
        booking['id'] = bookingLabels['id'];
        booking['pu_PickUp_By_Date'] = moment(this.state.puDateTime).format('YYYY-MM-DD');
        booking['pu_PickUp_By_Time_Hours'] = moment(this.state.puDateTime).hour();
        booking['pu_PickUp_By_Time_Minutes'] = moment(this.state.puDateTime).minute();
        this.props.updateBooking(booking.id, booking);
        this.setState({puTzEditMode: false});
    }

    onDateTimeChange(date) {
        const now = new Date();

        if (date.getTime() < now.getTime()) {
            this.notify('Please select future date time');
            return;
        }

        this.setState({puDateTime: date});
    }

    render() {
        const {bookingLabels, pricingInfos, errorMessage, loadingBookingLabel, clientname, booking } = this.props;
        const {puDateTime, puTzEditMode} = this.state;
        let sscc_trs = [];
        let index = 0;
        let _pricingInfos = [];
        let errorList = [];
        const now = new Date();

        if (pricingInfos) {
            const scanned_pricings = pricingInfos.filter(pricingInfo => pricingInfo.packed_status === 'scanned');
            _pricingInfos = scanned_pricings.length > 0 ? scanned_pricings : pricingInfos;
        }

        if (bookingLabels) {
            if (bookingLabels['b_error_Capture']) {
                // Errors are joined with delimiter('***')
                errorList = bookingLabels['b_error_Capture']
                    .split('***')
                    .map((error, index) => {
                        if (error.indexOf('Error') !== -1)
                            return (<li key={index} className={'c-red ignored-items'}>{index + 1}) {error}</li>);
                        else
                            return (<li key={index} className={'c-orange ignored-items'}>{index + 1}) {error}</li>);
                    });
            }
            for (const value of Object.entries(bookingLabels.sscc_obj)) {
                const sscc = value[0];

                bookingLabels.sscc_obj[sscc].map((sscc_info, sscc_info_index) => {
                    index++;
                    const tr = (
                        <tr key={index}>
                            {sscc_info_index === 0 && <td rowSpan={bookingLabels.sscc_obj[sscc].length.toString()}>{sscc}</td>}
                            <td>{sscc_info['e_item_type']}</td>
                            <td>{sscc_info['e_item']}</td>
                            <td>{sscc_info['e_qty']}</td>
                            <td>{sscc_info['e_type_of_packaging']}</td>
                            {sscc_info_index === 0 &&
                                <td rowSpan={bookingLabels.sscc_obj[sscc].length.toString()}>
                                    <Button
                                        color="info"
                                        disabled={!sscc_info.is_available && 'disabled'}
                                        onClick={() => this.onClickPreview(sscc_info['url'])}
                                        title={sscc_info.is_available ? 'Click to preview' : 'Please rebuild the label'}
                                    >
                                        Preview
                                    </Button>
                                    <Button
                                        color="primary"
                                        disabled={!sscc_info.is_available && 'disabled'}
                                        onClick={() => this.onClickPrint(sscc_info['pdf'])}
                                        title={sscc_info.is_available ? 'Click to print' : 'Please rebuild the label'}
                                    >
                                        Print
                                    </Button>
                                    <Button
                                        color="primary"
                                        disabled={!sscc_info.is_available && 'disabled'}
                                        onClick={() => this.onClickDownload(sscc_info['url'])}
                                        title={sscc_info.is_available ? 'Click to download' : 'Please rebuild the label'}
                                    >
                                        Download(ZPL)
                                    </Button>
                                </td>
                            }
                        </tr>
                    );

                    sscc_trs.push(tr);
                });
            }
        }
        return (
            <LoadingOverlay 
                active={loadingBookingLabel || this.state.isBooking}
                spinner
                text='Loading...'
                styles={{
                    spinner: (base) => ({
                        ...base,
                        '& svg circle': {
                            stroke: '#048abb'
                        }
                    })
                }}
            >
                <section className="label">
                    {!bookingLabels ?
                        this.state.errorMessage ?
                            <div className="error-msg">
                                <p className="">
                                    {this.state.errorMessage}
                                </p>
                            </div>
                            :
                            <p className="info">Loading...</p>
                        :
                        <div >
                            {['MRL Sampson', 'Deliver-ME', 'Deliver-Me Direct'].includes(bookingLabels.vx_freight_provider) ? (
                                <div>
                                    {!bookingLabels.b_dateBookedDate ? (
                                        <div className="text-center" style={{position:'absolute', top:-70, left:'50%'}}>
                                            <button className="btn btn-primary " onClick={() => this.onBookCreateLabel()}>
                                                Book & Create Labels 
                                            </button>
                                        </div>
                                    ) : null}
                                    <h5 className="comment">
                                        The freight provider for this booking requires it to be booked first before generating labels. The label print and preview buttons are unavailable to allow you to confirm the booking’s details first. If the details are correct, click the “Book & Create Labels” button to generate labels you can print. <br/> If any details need correction, close this screen, update the information in Deliver-ME, re-run the Freght Calculator for pricing, then click Book and thereafter ‘View Label’ to print the required labels. 
                                    </h5>
                                </div>
                                
                            ) :null}
                            <h4><i className="fa fa-circle"></i> Main Info:</h4>
                            
                            <div style={{display:'flex'}}>
                                <div className="main-info">
                                    <p><strong>DME Booking ID: </strong>{bookingLabels.b_bookingID_Visual}</p>
                                    <p><strong>Client name: </strong>{bookingLabels.b_client_name}</p>
                                    <p><strong>Client order number: </strong>{bookingLabels.b_client_order_num}</p>
                                    <p><strong>Client invoice number: </strong>{bookingLabels.b_client_sales_inv_num}</p>
                                    <p><strong>Freight provider: </strong>{bookingLabels.vx_freight_provider}</p>
                                    <p><strong>Consignment number: </strong>{bookingLabels.v_FPBookingNumber}</p>
                                    <p><strong>No of sscc: </strong>{bookingLabels.no_of_sscc}</p>
                                    <section>
                                        <p><strong>Pickup date: </strong></p>
                                        {(clientname && puTzEditMode) ?
                                            <DatePicker
                                                id="puPickUpAvailFrom_Date"
                                                selected={puDateTime}
                                                onChange={(date) => this.onDateTimeChange(date)}
                                                dateFormat="dd MMM yyyy h:mm aa"
                                                className=""
                                                showTimeSelect
                                                required
                                                minDate={now}
                                            />
                                            : moment(puDateTime).format('DD/MM/YYYY h:mm a')
                                        }
                                        {puTzEditMode ?
                                            <Button
                                                className="custom-button edit-pu-btn btn-primary"
                                                onClick={(e) => this.onClickSavePU(e)}
                                            >
                                                <i className="fa fa-save" aria-hidden="true"></i>
                                            </Button>
                                            :
                                            <Button
                                                className="custom-button edit-pu-btn btn-primary"
                                                onClick={(e) => this.onClickEditPU(e)}
                                            >
                                                <i className="fa fa-pencil-alt" aria-hidden="true"></i>
                                            </Button>
                                        }
                                    </section>
                                    <p><strong>Manifest date: </strong>{bookingLabels.manifest_timestamp && moment(bookingLabels.manifest_timestamp).format('DD/MM/YYYY HH:mm')}</p>
                                    {bookingLabels.quotes_cnt === 0 &&
                                        <p>
                                            <strong>Error: </strong>
                                            Sales order {bookingLabels['b_client_order_num']} has either address and / or item line errors in it preventing freight being booked. <br />
                                            Please go Deliver-ME booking <a href={`/booking/?bookingid=${bookingLabels.id}`} target='_blank' rel="noopener noreferrer">{bookingLabels.id}</a> and review the address and line information. <br />
                                            When complete click &apos;Update&apos; and then &apos;Price & Time Calc (FC)&apos;. Select the appropriate provider. <br />
                                            Your booking will then be ready for freight and freight labels can be printed from the Pronto &apos;Enquire by Package&apos; screen.
                                        </p>
                                    }
                                </div>
                                {['MRL Sampson', 'Deliver-ME', 'Deliver-Me Direct'].includes(bookingLabels.vx_freight_provider) && (
                                    <div style={{display:'flex'}}>
                                        <div className="main-info" style={{width:450}}>
                                            <p><strong>Sender: </strong>{bookingLabels.puCompany}</p>
                                            <p><strong>Address Street1: </strong>{bookingLabels.pu_Address_Street_1}</p>
                                            <p><strong>Address Street2: </strong>{bookingLabels.pu_Address_street_2}</p>
                                            <p><strong>Suburb: </strong>{bookingLabels.pu_Address_Suburb}</p>
                                            <p><strong>PostalCode: </strong>{bookingLabels.pu_Address_PostalCode}</p>
                                            <p><strong>State: </strong>{bookingLabels.pu_Address_State}</p>
                                            <p><strong>Phone: </strong>{bookingLabels.pu_Phone_Main}</p>
                                        </div>
                                        <div className="main-info" style={{width:450}}>
                                            <p><strong>Delivery: </strong>{bookingLabels.deToCompanyName}</p>
                                            <p><strong>Address Street1: </strong>{bookingLabels.de_To_Address_Street_1}</p>
                                            <p><strong>Address Street2: </strong>{bookingLabels.de_To_Address_Street_2}</p>
                                            <p><strong>Suburb: </strong>{bookingLabels.de_To_Address_Suburb}</p>
                                            <p><strong>PostalCode: </strong>{bookingLabels.de_To_Address_PostalCode}</p>
                                            <p><strong>State: </strong>{bookingLabels.de_To_Address_State}</p>
                                            <p><strong>Phone: </strong>{bookingLabels.de_to_Phone_Main}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                            
                            <ul>{errorList}</ul>
                            <h4><i className="fa fa-circle"></i> SSCC Info:  </h4>
                            <div className="label-type-selector">
                                <input type="radio"
                                    id="label-type"
                                    value="label"
                                    checked={this.state.selectedLabelType === 'label'}
                                    onChange={(e) => this.setState({ selectedLabelType: e.target.value })}
                                />
                                <label htmlFor="label-type">Label</label>
                                <input type="radio"
                                    id="consignment-type"
                                    value="consignment"
                                    checked={this.state.selectedLabelType === 'consignment'}
                                    onChange={(e) => this.setState({ selectedLabelType: e.target.value })}
                                />
                                <label htmlFor="consignment-type">Consignment</label>
                                <input type="radio"
                                    id="docket-type"
                                    value="docket"
                                    checked={this.state.selectedLabelType === 'docket'}
                                    onChange={(e) => this.setState({ selectedLabelType: e.target.value })}
                                />
                                <label htmlFor="docket-type">Delivery Docket</label>
                            </div>
                            {errorMessage ? (
                                <div className="error-msg">
                                    <p className="">
                                        {this.state.errorMessage}
                                    </p>
                                </div>
                            ) : (
                                <div>
                                    {this.state.selectedLabelType !== 'docket' ? (
                                        <div className="sscc-info">
                                            <table className="table table-hover table-bordered sortable fixed_headers">
                                                <thead>
                                                    <tr>
                                                        <th style={{width: '15%'}}>SSCC</th>
                                                        <th style={{width: '10%'}}>Code</th>
                                                        <th style={{width: '20%'}}>Description</th>
                                                        <th style={{width: '10%'}}>Qty</th>
                                                        <th style={{width: '10%'}}>Type of Package</th>
                                                        {<th style={{width: '10%'}}>Preview</th>}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {sscc_trs}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null}
                                    <div className="action">
                                        {bookingLabels.full_label_name &&
                                            <Button
                                                color="info"
                                                disabled={bookingLabels.pdf ? false : true}
                                                onClick={() => this.onClickPreview(bookingLabels.full_label_name)}
                                                title={bookingLabels.pdf ? 'Click to preview' : 'Please rebuild the label'}
                                            >
                                                Preview
                                            </Button>
                                        }
                                        <Button
                                            color="primary"
                                            disabled={bookingLabels.pdf ? false : true}
                                            onClick={() => this.onClickPrint()}
                                            title={bookingLabels.pdf ? 'Click to print' : 'Please rebuild the label'}
                                        >
                                            Print
                                        </Button>
                                        {bookingLabels.full_label_name &&
                                            <Button
                                                color="primary"
                                                disabled={bookingLabels.pdf ? false : true}
                                                onClick={() => this.onClickDownload(bookingLabels.full_label_name)}
                                                title={bookingLabels.pdf ? 'Click to download' : 'Please rebuild the label'}
                                            >
                                                Download(ZPL)
                                            </Button>
                                        }
                                    </div>
                                </div>
                            )}
                            <h4><i className="fa fa-circle"></i> Cost Comparison:</h4>
                            <Button color="info" onClick={() => this.onClickOpenPricingSlider()} className="see-all-quotes">See all quotes</Button>
                            {(bookingLabels && bookingLabels.quote && bookingLabels.quote.cheapest) &&
                                <div className="cost-comparision">
                                    <p>
                                        <strong>Current Provider: </strong>
                                        {bookingLabels.quote.original &&
                                            `${bookingLabels.quote.original.fp} Quoted Cost at Time of Order: $${parseFloat(bookingLabels.quote.original.cost_dollar).toFixed(2)}, `
                                        }
                                        {bookingLabels.quote.scanned &&
                                            `${bookingLabels.quote.scanned.fp} Quoted Cost at Time of Order: $${parseFloat(bookingLabels.quote.scanned.cost_dollar).toFixed(2)}`
                                        }
                                    </p><br />
                                    <p>
                                        <strong>Most Cost Effective Provider: </strong> 
                                        {bookingLabels.quote.cheapest.fp} Quoted Cost on Actual DIMS: 
                                        ${parseFloat(bookingLabels.quote.cheapest.cost_dollar).toFixed(2)}, Savings: ${parseFloat(bookingLabels.quote.cheapest.savings).toFixed(2)}
                                    </p>
                                    <Button color="info" onClick={() => this.onClickUseCheapest(bookingLabels.quote.cheapest)}>YES CHANGE</Button>
                                </div>
                            }

                            <FPPricingSlider
                                isOpen={this.state.isShowFPPricingSlider}
                                toggleSlider={this.toggleFPPricingSlider}
                                pricings={_pricingInfos}
                                onSelectPricing={(pricingInfo, isLocking) => this.onSelectPricing(pricingInfo, isLocking)}
                                isLoading={this.state.loadingPricingInfos}
                                x_manual_booked_flag={bookingLabels.x_manual_booked_flag}
                                api_booking_quote_id={bookingLabels.api_booking_quote}
                                is_quote_locked={bookingLabels.is_quote_locked}
                                onLoadPricingErrors={this.onLoadPricingErrors}
                                errors={this.state.errors}
                                isBooked={bookingLabels.b_dateBookedDate ? true : false}
                                clientname={this.props.clientname}
                                clientSalesTotal={bookingLabels.client_sales_total}
                                booking={booking}
                            />
                        </div>
                    }

                    
                </section>
            </LoadingOverlay>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        errorMessage: state.booking.errorMessage,
        pricingInfos: state.booking.pricingInfos,
        bookingLabels: state.booking.bookingLabels,
        loadingBookingLabel: state.booking.loadingBookingLabel,
        booking: state.booking.booking
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBooking: (id, filter) => dispatch(getBooking(id, filter)),
        getLabels4Booking: (identifier, labelType) => dispatch(getLabels4Booking(identifier, labelType)),
        getPricingInfos: (id) => dispatch(getPricingInfos(id)),
        fpLabel: (bookingId, vx_freight_provider) => dispatch(fpLabel(bookingId, vx_freight_provider)),
        fpBook: (bookingId, vx_freight_provider) => dispatch(fpBook(bookingId, vx_freight_provider)),
        updateBooking: (id, booking) => dispatch(updateBooking(id, booking)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LabelPage);



// WEBPACK FOOTER //
// ./src/pages/customer/LabelPage.js